import React from "react";
import {
  Modal,
  Form,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from "reactstrap";

const EditSubAdmin = ({
  editModal,
  edittoggle,
  handleUpdateAdmin,
  formData,
  handleInputChange,
  pageRoles,
  isLoading
}) => {
  return (
    <div>
      <Modal isOpen={editModal} toggle={edittoggle}>
        <ModalHeader toggle={edittoggle}>Edit Restaurant Details</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleUpdateAdmin}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="name">First Name</Label>
                  <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    placeholder="Enter First Name"
                    value={formData?.firstName}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="location">Last Name</Label>
                  <Input
                    type="text"
                    name="lastName"
                    id="last-name"
                    placeholder="Enter Last Name"
                    value={formData?.lastName}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="exampleSelect">Role</Label>
              <Input
                id="exampleSelect"
                name="role"
                type="select"
                value={editModal && formData?.role}
                className="text-capitalize"
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select Role
                </option>
                {pageRoles?.map((role, index) => {
                  return (
                    <option
                      key={index}
                      value={role}
                      className="text-capitalize"
                    >
                      {role}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>

            <div className="d-flex justify-content-end">
              <Button color="primary" disabled={isLoading} type="submit">
                {isLoading ? <Spinner size="sm" /> : "Update"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default EditSubAdmin;
